import {interp} from './common.func';
import {INTONATION_STEP, WORD_ITYPE} from './pitch.const';


// 고저값에 따른 마스크 값 매핑
const MAP_ITYPE_MAST = new Map<number, number>([
  [1, 4],
  [2, 2 + 4],   // 2는 중>하 라서 중(2)+하(4) = 6
  [3, 2],
  [4, 2 + 1],   // 4는 중>상 라서 중(2)+상(1) = 3
  [5, 1],
]);


export function getWordIType(intonations: Array<number>): WORD_ITYPE
{
  let ret = WORD_ITYPE.NONE;

  intonations.forEach(intonation => {
    const mask = MAP_ITYPE_MAST.get(intonation);
    if (mask) {
      // tslint:disable-next-line:no-bitwise
      ret |= mask;
    }
    else {
      console.error('invalid intonation = ', intonation);
    }
  });
  return ret;
}


function getAvg(fArray: Array<number>): number {
  const noNaN = fArray.filter(v => !isNaN(v));
  return noNaN.reduce((sum, value) => sum + value, 0) / noNaN.length;
}

function getMinMax(fArray: Array<number>): [number, number] {
  let min;
  let max;
  fArray.filter(v => !isNaN(v))
        .forEach(v => {
          min = min ? (v < min ? v : min) : v;
          max = max ? (v > max ? v : max) : v;
        });
  return [min, max];
}

function getRangeArray(fArray: Array<number>, min: number, max: number): Array<number> {
  return fArray.filter(v => !isNaN(v) && min < v && v < max);
}


// 중간 높이 값을 얻는 함수
export function getMidPitch(iType: WORD_ITYPE, fArray: Array<number>): number
{
  // console.log('getMidPitch()', iType, fArray);

  switch (iType) {
    case WORD_ITYPE.ITYPE1: // 상
      return getAvg(fArray) - INTONATION_STEP;
    case WORD_ITYPE.ITYPE2: // 중
      return getAvg(fArray);
    case WORD_ITYPE.ITYPE3: // 상중
    {
      const [min, max] = getMinMax(fArray);
      const mid = interp(min, max, 0.5);
      const range = getRangeArray(fArray, min, mid);
      const avg = getAvg(range);
      console.log('ITYPE3: ', min, max, mid, range, avg);
      return min;
    }
    case WORD_ITYPE.ITYPE4: // 하
      return getAvg(fArray) + INTONATION_STEP;
    case WORD_ITYPE.ITYPE6: // 중하
    {
      const [min, max] = getMinMax(fArray);
      const mid = interp(min, max, 0.5);
      const range = getRangeArray(fArray, mid, max);
      const avg = getAvg(range);
      console.log('ITYPE6: ', min, max, mid, range, avg);
      return avg;
    }
    case WORD_ITYPE.ITYPE5: // 상하
    case WORD_ITYPE.ITYPE7: // 상중하
    {
      const [min, max] = getMinMax(fArray);
      const mid1 = interp(min, max, 1 / 3);
      const mid2 = interp(min, max, 2 / 3);
      const range = getRangeArray(fArray, mid1, mid2);
      return (range && range.length > 0) ? getAvg(range) : interp(min, max, 0.5);
    }
    default:
      console.error('getMidPitch(): invalid iType', iType);
  }
  return 0;
}
